import { useMemo } from 'react';
import { Box, TextField, Button, Theme, Stack, InputAdornment, IconButton } from '@mui/material';
import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import { useDropdownContext } from './DropdownContext';

export const DropdownFilters = <T extends string | number>() => {
  const { 
    searchTerm, 
    setSearchTerm, 
    filteredOptions, 
    value,
    handleSelectAll,
    handleClearAll
  } = useDropdownContext<T>();

  const isAnyFilteredSelected = useMemo(() => {
    // Check if any visible item is currently in the selection list
    return filteredOptions.some(opt => value.includes(opt.id));
  }, [filteredOptions, value]);

  const allFilteredSelected = useMemo(() => {
    if (filteredOptions.length === 0) return false;
    return filteredOptions.every(opt => value.includes(opt.id));
  }, [filteredOptions, value]);


  const showButtons = filteredOptions.length > 0;

  return (
    <Box sx={{ p: 2, borderBottom: (theme:Theme) => `1px solid ${theme.palette.divider}` }}>
      <TextField
        sx={{ mb: 2 }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search by name, date, or label..."
        fullWidth
        autoFocus
        margin="none"
        size="small"
        slotProps={{
          input: {
            startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>,
            endAdornment: searchTerm ? (
              <InputAdornment position="end">
                <IconButton onClick={() => setSearchTerm('')} size="small">
                  <ClearIcon sx={{ cursor: 'pointer' }} fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null
          }
        }}
      />
      {showButtons && (
        <Stack direction="row" spacing={1} sx={{ mt: 1, pt: 0.5 }}>
          <Button 
            size="small"
            onClick={handleSelectAll}
            disabled={allFilteredSelected} // Disable if everything is already selected
          >Select All ({filteredOptions.length})</Button>
          <Button 
            size="small"
            onClick={handleClearAll}
            disabled={!isAnyFilteredSelected} // Disable if nothing in the list is selected
          >
            Clear All ({
              filteredOptions.filter(opt => value.includes(opt.id)).length
            })
          </Button>

        </Stack>
      )}
    </Box>
  );
};